module.exports = __webpack_public_path__ + "img/1.bd21d4b2.jpg";